(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slinkis-apps"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sl-apps-section').forEach(section=>{const track=section.querySelector('.sl-apps-grid'),cards=[...track.children],prev=section.querySelector('[data-app-prev]'),next=section.querySelector('[data-app-next]'),position=section.querySelector('[data-app-position]');const step=()=>cards[0].getBoundingClientRect().width+16;const update=()=>{const n=Math.round(track.scrollLeft/step());position.textContent=(n+1)+' / '+cards.length;prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};prev.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));next.addEventListener('click',()=>track.scrollBy({left:step(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}));track.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);update();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slinkis-header"]) return;
  try {
    
document.querySelectorAll('.sl-catalog').forEach(catalog=>{
 const summary=catalog.querySelector('summary');
 catalog.addEventListener('keydown',event=>{if(event.key==='Escape'&&catalog.open){catalog.open=false;summary.focus();event.preventDefault();}});
 document.addEventListener('click',event=>{if(!catalog.contains(event.target))catalog.open=false;});
});
document.addEventListener('click',event=>{
 const link=event.target.closest('a');
 if(!link||!link.closest('.sl-header,.sl-hero-carousel')||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
 const url=new URL(link.href,window.location.href);
 if(url.origin!==location.origin||!['#sl-art','#wall-clings','#sl-studio','#studio-apps','#studio-cartoons','#studio-projects','#studio-shop'].includes(url.hash))return;
 event.preventDefault();
 event.stopPropagation();
 document.querySelectorAll('.sl-catalog[open]').forEach(menu=>{menu.open=false;});
 const samePage=url.pathname.replace(/\/$/,'')===location.pathname.replace(/\/$/,'');
 const target=samePage?document.getElementById(url.hash.slice(1)):null;
 if(target){
  if(location.hash!==url.hash)history.pushState(null,'',url.hash);
  requestAnimationFrame(()=>{target.setAttribute('tabindex','-1');target.focus({preventScroll:true});target.scrollIntoView({behavior:'auto',block:'start'});});
 }else{
  location.assign(url.href);
 }
},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slinkis-poster-gallery"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ss-gallery').forEach(gallery => {
  const track = gallery.querySelector('.ss-gallery-grid');
  const cards = [...track.children];
  const previous = gallery.querySelector('[data-poster-prev]');
  const next = gallery.querySelector('[data-poster-next]');
  const position = gallery.querySelector('.ss-carousel-position');
  const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
  const update = () => {
    const index = Math.round(track.scrollLeft / step());
    position.textContent = (index + 1) + ' / ' + cards.length;
    previous.disabled = track.scrollLeft < 2;
    next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
  };
  const move = direction => track.scrollBy({left:direction * step(),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  track.addEventListener('scroll', update, {passive:true});
  track.addEventListener('keydown', event => {if(event.target !== track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
  window.addEventListener('resize',update);
  update();
});

document.querySelectorAll('.ss-gallery').forEach(gallery => {
  const dialog = gallery.querySelector('.ss-artwork-dialog');
  const image = dialog.querySelector('img');
  const title = dialog.querySelector('h2');
  let opener = null;
  let pushed = false;
  let pageX = 0;
  let pageY = 0;
  const open = link => {
    if (!dialog.open) {
      pageX = window.scrollX;
      pageY = window.scrollY;
    }
    opener = link;
    image.src = link.dataset.artworkSrc;
    image.alt = link.dataset.artworkAlt;
    title.textContent = link.dataset.artworkTitle;
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('button').focus({preventScroll:true});
  };
  const close = () => {
    if (dialog.open) dialog.close();
    if (opener) opener.focus({preventScroll:true});
    window.scrollTo(pageX,pageY);
  };
  const back = () => {
    close();
    if (pushed) {pushed=false;history.back();}
    else {const url=new URL(location.href);url.hash='sl-art';history.replaceState(history.state,'',url);}
  };
  gallery.querySelectorAll('[data-artwork-view]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    open(link);
    const url=new URL(location.href);
    url.hash=link.dataset.artworkId;
    history.pushState({artworkViewer:true},'',url);
    pushed=true;
  }));
  dialog.querySelector('.ss-artwork-back').addEventListener('click',back);
  dialog.addEventListener('cancel',event=>{event.preventDefault();back();});
  window.addEventListener('popstate',()=>{
    const link=[...gallery.querySelectorAll('[data-artwork-view]')].find(link=>'#'+link.dataset.artworkId===location.hash);
    if(link){pushed=true;open(link);}else{pushed=false;close();}
  });
  const initial=[...gallery.querySelectorAll('[data-artwork-view]')].find(link=>'#'+link.dataset.artworkId===location.hash);
  if(initial)open(initial);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slinkis-slime"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sl-hero-carousel').forEach(carousel=>{
 const slides=[...carousel.querySelectorAll('[data-hero-slide]')],toggle=carousel.querySelector('[data-hero-toggle]'),position=carousel.querySelector('.sl-hero-position'),reduced=matchMedia('(prefers-reduced-motion: reduce)');
 let index=0,timer=null,paused=reduced.matches;
 const paint=()=>{slides.forEach((slide,i)=>{slide.hidden=i!==index;slide.inert=i!==index;slide.setAttribute('aria-hidden',String(i!==index));});position.textContent=(index+1)+' / '+slides.length;};
 const stop=()=>{if(timer)clearInterval(timer);timer=null;};
 const label=()=>{toggle.textContent=paused?carousel.dataset.playLabel:carousel.dataset.pauseLabel;};
 const run=()=>{stop();if(!paused&&!document.hidden)timer=setInterval(()=>{index=(index+1)%slides.length;paint();},3500);label();};
 const pause=()=>{paused=true;stop();label();};
 const move=direction=>{pause();index=(index+direction+slides.length)%slides.length;paint();};
 carousel.querySelector('[data-hero-prev]').addEventListener('click',()=>move(-1));
 carousel.querySelector('[data-hero-next]').addEventListener('click',()=>move(1));
 toggle.addEventListener('click',()=>{paused=!paused;run();});
 carousel.addEventListener('focusin',event=>{if(event.target!==toggle)pause();});
 carousel.addEventListener('mouseenter',()=>{stop();});
 carousel.addEventListener('mouseleave',()=>{run();});
 carousel.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
 document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();else run();});
 reduced.addEventListener('change',event=>{if(event.matches)pause();});
 paint();run();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slinkis-wall-clings"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ss-wall-clings').forEach(section=>{
 const track=section.querySelector('.ss-wall-track'),cards=[...track.children],prev=section.querySelector('[data-wall-prev]'),next=section.querySelector('[data-wall-next]'),position=section.querySelector('.ss-wall-position');
 const step=()=>cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:track.clientWidth;
 const update=()=>{position.textContent=(Math.round(track.scrollLeft/step())+1)+' / '+cards.length;prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;};
 const move=d=>track.scrollBy({left:d*step(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
 prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update);track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});update();
});

  } catch(e) { console.error(e); }
})();
})();
